import { Image } from 'foundations-components/transitional/components/Image';

// @ts-expect-error svg import
import SalesHubSvg from 'bender-url!./images/SalesHub.svg';
// @ts-expect-error svg import
import SalesHubEntSvg from 'bender-url!./images/SalesHub_Ent.svg';
// @ts-expect-error svg import
import SalesHubProSvg from 'bender-url!./images/SalesHub_Pro.svg';
// @ts-expect-error svg import
import SalesHubStarterSvg from 'bender-url!./images/SalesHub_Starter.svg';
import { MERCH_CARD_PRODUCT_ICON_STYLE_PROPS, PRODUCT_PAGE_TITLE_PRODUCT_ICON_STYLE_PROPS } from './styleProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SalesHubProductIcon = ({
  useCase = 'productPageTitle'
}) => {
  return /*#__PURE__*/_jsx(Image, Object.assign({
    src: SalesHubSvg
  }, useCase === 'productPageTitle' ? PRODUCT_PAGE_TITLE_PRODUCT_ICON_STYLE_PROPS : MERCH_CARD_PRODUCT_ICON_STYLE_PROPS));
};
export const SalesHubStarterProductIcon = ({
  useCase = 'merchCard'
}) => {
  return /*#__PURE__*/_jsx(Image, Object.assign({
    src: SalesHubStarterSvg
  }, useCase === 'productPageTitle' ? PRODUCT_PAGE_TITLE_PRODUCT_ICON_STYLE_PROPS : MERCH_CARD_PRODUCT_ICON_STYLE_PROPS));
};
export const SalesHubProfessionalProductIcon = ({
  useCase = 'merchCard'
}) => {
  return /*#__PURE__*/_jsx(Image, Object.assign({
    src: SalesHubProSvg
  }, useCase === 'productPageTitle' ? PRODUCT_PAGE_TITLE_PRODUCT_ICON_STYLE_PROPS : MERCH_CARD_PRODUCT_ICON_STYLE_PROPS));
};
export const SalesHubEnterpriseProductIcon = ({
  useCase = 'merchCard'
}) => {
  return /*#__PURE__*/_jsx(Image, Object.assign({
    src: SalesHubEntSvg
  }, useCase === 'productPageTitle' ? PRODUCT_PAGE_TITLE_PRODUCT_ICON_STYLE_PROPS : MERCH_CARD_PRODUCT_ICON_STYLE_PROPS));
};